import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const CaseStudyCard = ({ caseStudy }) => {
  return (
    <div className="bg-card rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border border-border h-full flex flex-col">
      <div className="relative h-48 md:h-56 overflow-hidden">
        <Image
          src={caseStudy?.image}
          alt={caseStudy?.imageAlt}
          className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4">
          <span className="inline-flex items-center space-x-1 bg-primary text-primary-foreground px-3 py-1 rounded-full text-xs font-medium font-body">
            <Icon name="Award" size={12} />
            <span>{caseStudy?.industry}</span>
          </span>
        </div>
      </div>
      <div className="p-6 flex-1 flex flex-col">
        <div className="flex items-center space-x-2 mb-3">
          <Image
            src={caseStudy?.clientLogo}
            alt={caseStudy?.clientLogoAlt}
            className="w-8 h-8 rounded-full object-cover"
          />
          <span className="text-sm font-medium text-muted-foreground font-body">{caseStudy?.clientName}</span>
        </div>
        
        <h3 className="text-lg md:text-xl font-bold font-headline text-foreground mb-3 line-clamp-2 flex-1">
          {caseStudy?.title}
        </h3>
        
        <p className="text-sm text-muted-foreground font-body mb-4 line-clamp-3">
          {caseStudy?.description}
        </p>
        
        <div className="grid grid-cols-3 gap-4 mb-6 py-4 border-y border-border">
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-success font-headline">{caseStudy?.metric1Value}</div>
            <div className="text-xs text-muted-foreground font-body mt-1">{caseStudy?.metric1Label}</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-accent font-headline">{caseStudy?.metric2Value}</div>
            <div className="text-xs text-muted-foreground font-body mt-1">{caseStudy?.metric2Label}</div>
          </div>
          <div className="text-center">
            <div className="text-xl md:text-2xl font-bold text-primary font-headline">{caseStudy?.metric3Value}</div>
            <div className="text-xs text-muted-foreground font-body mt-1">{caseStudy?.metric3Label}</div>
          </div>
        </div>
        
        <Link
          to="/contact"
          className="inline-flex items-center justify-center space-x-2 bg-primary text-primary-foreground px-4 py-2 rounded-lg hover:bg-primary/90 transition-colors duration-200 text-sm font-medium font-body"
        >
          <span>View Case Study</span>
          <Icon name="ExternalLink" size={16} />
        </Link>
      </div>
    </div>
  );
};

export default CaseStudyCard;